import { AvField, AvForm } from "availity-reactstrap-validation";
import { withNamespaces } from "react-i18next";
import { Col, Label, PopoverBody, Row, UncontrolledPopover } from "reactstrap";
import Dropzone from "react-dropzone";
import { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "src/modules/3rd-party-management/constants";
import { connect } from "react-redux";
import ButtonsGroup from "../ButtonsGroup";

const UploadFile = ({ token, t, onValidSubmit, onBackClicked }) => {
    const [ file, setFile ] = useState(null);

    const onUploadProgress = (e, setFile) => {
        const { total, loaded, lengthComputable } = e
        if (lengthComputable) {
            const uploadedPercent = (loaded / total) * 100

            setFile((currentState) => {
                return {
                    ...currentState,
                    uploadedPercent: uploadedPercent
                }
            })
        }
    }

    const handleAcceptedFile = (files) => {
        const headers = {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress: null
        }

        const xFile = files[0];

        console.log(xFile);

        const fileToUpload = {
            ...xFile,
            id: null,
            status: 'uploading',
            name: xFile.name,
            type: xFile.type,
            uploadedPercent: 0,
            preview: URL.createObjectURL(xFile),
            formattedSize: xFile.size,
            attachmentSize: xFile.size
        }

        setFile(fileToUpload);

        axios.post(`${API_BASE_URL}/product/attachment/upload`, {
            file: xFile
        }, {
            ...headers,
            onUploadProgress: (e) => {
                onUploadProgress(e, setFile)
            }
        }).then((response) => {
            if (response.status === 200) {
                const fileData = response.data.data

                setFile((currentState) => {
                    return {
                        ...currentState,
                        status: 'upload_succeed',
                        id: fileData.id
                    }
                })
            }
            else {
                setFile((currentState) => {
                    return {
                        ...currentState,
                        status: 'upload_failed'
                    }
                })
            }
        }).catch((_error) => {
            setFile((currentState) => {
                return {
                    ...currentState,
                    status: 'upload_failed'
                }
            })
        })
    }

    console.log(file);

    return (
        <AvForm 
            onValidSubmit={(_e, values) => {
                onValidSubmit(values)
            }} 
            className="needs-validation"
        >
            <Row>
                <Col sm='12'>
                    <Label for="ddsDocumentId">
                        {t("Upload DDS Document")} <span className="text-danger">*</span>
                    </Label>
                    <Dropzone
                        onDrop={handleAcceptedFile}
                        maxFiles={1}
                        multiple={false}
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.txt,.jpg,.jpeg,.png"
                    >
                        {({ getRootProps, getInputProps }) => (
                            <div className="dropzone tpdd p-3">
                                <div
                                    className="dz-message needsclick"
                                    {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <button type="button" className="btn select-files-btn">
                                        {t('Select file...')}
                                    </button>
                                    <h5>
                                        <span className="me-1">
                                            {t(
                                                "Drop file here or click to upload"
                                            )}
                                        </span>
                                        <i
                                            className="ri-information-line align-middle"
                                            id="upload-dds-doc-file-help"
                                        />
                                    </h5>
                                    <UncontrolledPopover
                                        placement="bottom"
                                        trigger="hover"
                                        target="upload-dds-doc-file-help"
                                    >
                                        <PopoverBody>
                                            <span>
                                                {t("Only .pdf, .doc, .docx, .xls, .xlsx, .ppt, .txt, .jpg,OR .png files are allowed.")}
                                            </span>
                                        </PopoverBody>
                                    </UncontrolledPopover>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                    <AvField
                        name="ddsDocumentId"
                        type="hidden"
                        errorMessage={t("This field cannot be blank")}
                        className="form-control"
                        validate={{
                            required: { value: true }
                        }}
                        id="ddsDocumentId"
                        value={file?.id}
                    />
                </Col>
            </Row>

            <ButtonsGroup
                onBackClicked={onBackClicked}
                onNextClicked={() => { }}
                nextButtonType='submit'
            />
        </AvForm>
    )
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;

    return {
        token
    }
}

export default withNamespaces()(
    connect(mapStatetoProps)(UploadFile)
);